import React from 'react';
import PropTypes from 'prop-types';
import 'nvd3/build/nv.d3.css';

export default function Legend({ data }) {
  const reverseData = [...data].reverse();
  return (
    <div className="pie-chart-legend">
      {reverseData.map((data) => (
        <div className="legend-item" key={`${data.line1}-${data.value}`}>
          <div className="legend-identifier-cell">
            <div className="legend-identifier" style={{ background: data.color }}></div>
          </div>
          <div className="legend-stats" tabIndex={0}>
            {data.line2}
          </div>
          <div className="legend-title" tabIndex={0}>
            {data.line1}
          </div>
        </div>
      ))}
    </div>
  );
}

Legend.propTypes = {
  data: PropTypes.array,
};
